export default [
    {
      reducerKey: 'finance/wallets',
      sagaKey: 'walletsSaga',
      importReducer: () => import(/* webpackChunkName: "domain-finance" */ 'modules/Finance/Wallets/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-finance" */ 'modules/Finance/Wallets/store/saga'),
    },
    {
      reducerKey: 'finance/payment-profiles',
      sagaKey: 'paymentProfilesSaga',
      importReducer: () => import(/* webpackChunkName: "domain-finance" */ 'modules/Finance/PaymentProfiles/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-finance" */ 'modules/Finance/PaymentProfiles/store/saga'),
    },
    {
      reducerKey: 'finance/invoices',
      sagaKey: 'invoicesSaga',
      importReducer: () => import(/* webpackChunkName: "domain-finance" */ 'modules/Finance/Invoices/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-finance" */ 'modules/Finance/Invoices/store/saga'),
    },
    {
      reducerKey: 'finance/promised-payment',
      sagaKey: 'promisedPaymentSaga',
      importReducer: () => import(/* webpackChunkName: "domain-finance" */ 'modules/Finance/PromisedPayment/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-finance" */ 'modules/Finance/PromisedPayment/store/saga'),
    },
    {
      reducerKey: 'billing',
      sagaKey: 'billingSaga',
      importReducer: () => import(/* webpackChunkName: "domain-finance" */ 'modules/Forms/Billing/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-finance" */ 'modules/Forms/Billing/store/saga'),
    },
    {
      reducerKey: 'payment-order',
      sagaKey: 'paymentOrderSaga',
      importReducer: () => import(/* webpackChunkName: "domain-finance" */ 'modules/Billing/PaymentOrder/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-finance" */ 'modules/Billing/PaymentOrder/store/saga'),
    },
]
